import { render, staticRenderFns } from "./register-sso.vue?vue&type=template&id=2e1825bf"
import script from "./register-sso.vue?vue&type=script&lang=js"
export * from "./register-sso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports